import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
const LiveMonitor = lazy(()=> import(/* webpackChunkName: "LiveMonitor" */'./components'));

const routes = () => <PrivateRoute exact path="/live-monitor" component={LiveMonitor} />;

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/livemonitor/LiveMonitor/routes.js